import * as actionTypes from './actionTypes'

export const removeSnackbar = (key) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_SNACKBAR,
    payload: { key },
  })
}
